import angular from 'angular';
import { CrmOrganizationsConfigurationController } from './crm-organizations-configuration.controller.js';
import { CrmStrategiesService } from './crm-strategies.services.js';
import { crmSyncConversation } from './crm-sync-conversation.directive.js';
import { CrmService } from './crm.service.js';
import { crmChildObjectAndRelationSelect } from './directives/crm-child-object-and-relation-select.directive.js';
import { crmFieldSelectAndLabel } from './directives/crm-field-select-and-label.directive.js';
import { crmGroupSelectAndLabel } from './directives/crm-group-select-and-label.directive.js';
import { crmObjectEntriesList } from './directives/crm-object-entries-list.directive.js';
import { crmSearchTypeSelectAndFields } from './directives/crm-search-type-select-and-fields.directive.js';
import { omnichannelConfiguration } from './salesforce/omnichannel-configuration.directive.js';
import { crmWidget } from './salesforce/widget.directive';

angular
  .module('parameters.crm', [])
  .controller('CrmOrganizationsConfigurationController', CrmOrganizationsConfigurationController)
  .factory('CrmFactory', CrmService.CrmFactory)
  .factory('CrmStrategiesFactory', CrmStrategiesService.CrmStrategiesFactory)
  .directive('crmFieldSelectAndLabel', crmFieldSelectAndLabel)
  .directive('crmGroupSelectAndLabel', crmGroupSelectAndLabel)
  .directive('crmSearchTypeSelectAndFields', crmSearchTypeSelectAndFields)
  .directive('crmChildObjectAndRelationSelect', crmChildObjectAndRelationSelect)
  .directive('crmObjectEntriesList', crmObjectEntriesList)
  .directive('omnichannelConfiguration', omnichannelConfiguration)
  .directive('crmSyncConversation', crmSyncConversation)
  .directive('crmWidget', crmWidget);
